import { Action } from 'redux';
export const GET_TERMS_OF_USE_CONTENTS = 'terms-of-use/GET_TERMS_OF_USE_CONTENTS';
export const GET_TERMS_OF_USE_PAGE_CONTENTS = 'terms-of-use/GET_TERMS_OF_USE_PAGE_CONTENTS';
export const UPDATE_TERMS_OF_USE_PAGE_CONTENTS = 'terms-of-use/UPDATE_TERMS_OF_USE_PAGE_CONTENTS';

/**
 * Get home page contents
 */
export interface GetTermsOfUseContentsAction extends Action<typeof GET_TERMS_OF_USE_CONTENTS> {
  payload: any;
}

export const getTermsOfUSeContents = (data: any): GetTermsOfUseContentsAction => ({
  type: GET_TERMS_OF_USE_CONTENTS,
  payload: data,
});

export const getTermsOfUSepageContents = () => {
  return {
    type: GET_TERMS_OF_USE_PAGE_CONTENTS,
  };
};

export const UpdateTermsOfUsePageContents = (data: any) => {
  return {
    type: UPDATE_TERMS_OF_USE_PAGE_CONTENTS,
    payload: data,
  };
};
